export default __webpack_public_path__ + "static/media/Donate.8baa5561.svg";